<template>
  <div>
    <w-g-list
        :pagination="false"
        :fieldInit="field"
        :keyField="'id'"
        :sortingFunctionGenerator="sortingFunctionGenerator"
        :headerItems="headerItems"
        :itemsToDisplay="tableItems"
    >
      <template v-slot:default="{element}">
        <project-bar 
          :projectData="element" 
          :view="'full'"
        ></project-bar>
      </template>
    </w-g-list>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ProjectBar from './ProjectBar.vue';
import WGList from '../../../../../world/spa/components/WGList.vue';

export default {
  props: {
    projectsData: {
      type: Array,
      default: () => [],
    },
    sortingFunctionGenerator: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      field: "name",
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    headerItems() {
      return [
        {
          field: 'projectId',
          label: this.$anm22.strLang(this.lang, 'Code', 'Codice'),
          class: 'wg-xs-3',
          style: {justifyContent: 'center'},
          disabled: false,
        },
        {
          field: 'name',
          label: this.$anm22.strLang(this.lang, 'Name', 'Nome'),
          class: 'wg-xs-6',
          style: {justifyContent: 'center'},
          disabled: false,
        },
        {
          field: 'staff',
          label: this.$anm22.strLang(this.lang, 'Staff', 'Staff'),
          class: 'wg-xs-3',
          style: {justifyContent: 'center'},
          disabled: true,
        }
      ]
    },
    tableItems() {
      return this.projectsData.map(pdata => {
        return {
          ...pdata,
          'list-metadata': {
            type: 'item',
          }
        }
      });
    }
  },
  components: {
    ProjectBar,
    WGList
  }
}
</script>

<style lang="scss" scoped>

</style>
